export enum BarTabStatusValues {
  OPEN = 'OPEN',
  LOCKED = 'LOCKED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  REVIEWED = 'REVIEWED',
}

export enum BarTabOrderTypeValues {
  BONG = 'BONG',
  LIST = 'LIST',
}
